<div class="headContent" fxFlex="100">
    <div class="gap-1 align-items-flex-end " fxLayout="row">
        <h5>
            Container LifeCycle
        </h5>
    </div>
    <button mat-raised-button (click)="addLifeCycle()" *ngIf="isShownTable"> Add</button>
    <!-- <span style="font-size: 12px">Last activity date: <b>{{last_activity_date | date:"dd MMM yyyy"}}</b></span> -->
</div>
<!-- <div fxFlex="100" class="introButton " [class.justify-content-start]="!isShownTable"> -->

<!-- </div> -->

<form [formGroup]="lifeCycleForm" *ngIf="!isShownTable" fxLayout="column" class="w-100">
    <div fxFlex="100" class="inputs justify-fxstart align-items-flex-start p-0" fxLayout="row">
        <div fxLayout="column" class=" align-items-flex-start ">
            <div class=" activityInput lcActivityInput ">
                <!-- Activity Location -->
                <!-- <app-mat-auto-search id="test" [isEditable]="true" [label]="'Activity Location*'"
                                     formControlName="current_location" [name]="'activity_location'"
                                     [displayField]="'name_display'"
                                     [idField]="null" [listUrl]="location_url+'?name=::search::'" fxFlex="100"
                                     fxFlex.gt-xs="13.8em"
                                     fxLayout="column" [errors]="errorObj.current_location"
                                     [labelItemTemplate]="lifecycleSelectedItem"
                                     [itemTemplate]="lifecycleItem">
                </app-mat-auto-search> -->
                <!-- <logzy-view-data-field label="Activity Location" [name]="containerObj.current_location"
                    [displayField]="'name_display'" fxFlex="12em" fxFlex.gt-xs="13.8em"
                    fxLayout="column"></logzy-view-data-field> -->
                <logzy-view-data-field label="Activity Location" [name]="containerObj?.current_location"
                                       [displayField1]="'name_display'" [displayField2]="'address'" fxFlex="100"
                                       fxLayout="column"
                                       class="align-items-center"></logzy-view-data-field>
                <!-- Company Name -->
                <ng-container *ngIf="lifycycleList.data[0].is_temporary_allocation == null">
                    <app-mat-auto-search id="test" [isEditable]="true" [label]="'Block for Customer'"
                                         formControlName="blocked_for_company" [name]="'activity_location'"
                                         [displayField]="'legal_name'"
                                         [idField]="null" [listUrl]="company_url+'?name=::search::'" fxFlex="100"
                                         fxFlex.gt-xs="13.8em"
                                         fxLayout="column" [errors]="errorObj.blocked_for_company">
                    </app-mat-auto-search>
                </ng-container>

                <!-- Activity Date -->
                <app-date-field [isEditable]='true' [label]="'Activity date*'" formControlName="activity_date"
                                [name]="'activity_date'" [maxDate]="currentDate" [minDate]="last_activity_date"
                                fxFlex="100"
                                fxFlex.gt-xs="13.8em" fxLayout="column" [errors]="errorObj.activity_date">
                </app-date-field>

                <!-- Notify Me On (Reminder Date) -->
                <!-- <app-date-field [isEditable]='true' [label]="'Notify me on'" formControlName="reminder_date"
                    [name]="'reminder_date'" [minDate]="currentDate" fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column"
                    [errors]="errorObj.reminder_date">
                </app-date-field> -->

            </div>


            <!-- Remarks -->
            <div class="remarksBox" fxLayout="row">
                <div class="expandable" fxFlex="100" fxFlex.gt-md="32em" fxLayout="column">
                    <textarea name="remark" class="h5emw100" id="" placeholder="Enter your remark here."
                              formControlName="remarks"></textarea>
                    <div class="icon-set">
                        <i MatSuffix id="i1" class="flaticon-attachment" matTooltip="Coming Soon"
                           matTooltipPosition="below" matTooltipHideDelay="2000"></i>
                        <i MatSuffix id="i1" class="flaticon-happy" matTooltip="Coming Soon" matTooltipPosition="below"
                           matTooltipHideDelay="2000"></i>
                        <button mat-icon-button><img src="assets/images/icons/send.svg" alt=""></button>
                    </div>
                </div>
                <ul *ngIf="errorObj?.remarks?.length" class="errorList">
                    <li *ngFor="let item of errorObj?.remarks" class="error">{{item}}</li>
                </ul>
            </div>
        </div>
        <!-- Lifecycle Status -->
        <div fxFlex="100" fxLayout="column">
            <div class="inputTitle" *ngIf="lifeCycleMasterList?.length">
                <span>Mark container as*</span>
            </div>
            <mat-chip-list formControlName="status">
                <mat-chip *ngFor="let item of lifeCycleMasterList" [value]="item.id" [selectable]="true"
                          (click)="lifeCycleMasterChipValue(item)">
                    {{item.name}}
                </mat-chip>
            </mat-chip-list>
            <ul *ngIf="errorObj?.status?.length" class="errorList">
                <li *ngFor="let item of errorObj?.status" class="error">{{item}}</li>
            </ul>
        </div>
    </div>
    <div class="btnb">
        <button mat-raised-button class="Cancel" (click)="backToList()"> Back</button>
        <button mat-raised-button class="Save" (click)="postLifeCycle()">Submit</button>
    </div>
</form>

<!-- Comments View -->
<!-- <div fxFlex="100" class="inputs justify-fxstart" fxLayout="row wrap">
    <div fxFlex="100" class="cardr1" fxLayout="row" *ngFor="let item of lifeCycleComments?.results">
        <div class="fxapart" fxFlex="11">
            <logzy-img-loader
                src="{{item?.created_by?.picture==null?
                item?.created_by?.gender=='Male'?'/assets/images/users/man.svg':'/assets/images/users/woman.svg':item?.created_by?.picture?.document_file}}"
                border_radius="50%" [profilePic]="true" [initials]="item?.created_by?.initials" [class.p-0]='true'>
            </logzy-img-loader>
        </div>
        <div class="remarks " fxFlex="85" fxLayout="row wrap">
            <div class="fxapart mb-1em" fxFlex="100">
                <div class="inputTitle">
                    <small>{{item?.created_by?.first_name}} {{item?.created_by?.last_name}}</small>
                </div>
                <div class="date" fxFlex="100">
                    <mat-chip color="Primary" selected>{{item?.status_display}}</mat-chip>
                    <small>Date: {{item?.activity_date | date:"dd MMM, yyyy"}}</small>
                </div>
            </div>
            <div class="rtext" fxFlex="100">
                <p>{{item?.remarks==null || item?.remarks=="" ? "-" : item?.remarks}}</p>
            </div>
            <div>
                <small>Activity location: </small>
                <mat-chip color="Primary">{{item?.activity_location?.name_display}}</mat-chip>
            </div>
        </div>
    </div>

</div> -->
<logzy-table-loader class="w-100" *ngIf="loading"></logzy-table-loader>
<div class="chargeList" *ngIf="isShownTable && !loading">
    <ng-container *ngIf="!lifycycleList?.data.length">
        <logzy-billu part1="No " part2="entries " part3="here." font="14px"></logzy-billu>
    </ng-container>
    <ng-container *ngIf="lifycycleList?.data.length">
        <div class="teamTable setTable">
            <mat-table [dataSource]="lifycycleList" matSort (matSortChange)="announceSortChange($event)">

                <ng-container matColumnDef="request_number">
                    <mat-header-cell *matHeaderCellDef> Request No.</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="cursor:pointer">
                        <span class="requestNo"
                              (click)="redirectToRequest(lifeCycleService.latestBlockForCompany?.request)">{{element.request?.request_number ?? '-'}}</span>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="fs-13">
                        <div fxLayout="column" class="gap-1">
                            <mat-chip [style.background]="element?.mnr_status?.color_code">{{element.status?.name}}
                            </mat-chip>

                        </div>

                        <!-- <mat-chip *ngIf="element.blocked_for_company!=null">Blocked</mat-chip> -->
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="current_location">
                    <mat-header-cell *matHeaderCellDef> Activity Location</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="fs-13">
                        {{element.current_location?.name}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="activity_date">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Activity date</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="fs-13">
                        <span *ngIf="element.blocked_at==null">{{(element.activity_date | date:'dd MMM, yyyy') ??
                        '-'}}</span>
                        <span *ngIf="element.blocked_at!=null">{{(element.blocked_at | date:'dd MMM, yyyy') ??
                        '-'}}</span>
                    </mat-cell>
                </ng-container>
                <!-- <ng-container matColumnDef="blocked_for_company">
                    <mat-header-cell *matHeaderCellDef> Blocked For Company</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="fs-13">
                        {{element.blocked_for_company?.name ?? '-'}}
                    </mat-cell>
                </ng-container> -->
                <ng-container matColumnDef="allocation_details">
                    <mat-header-cell *matHeaderCellDef> Allocation Details</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="fs-13">
                        {{element.blocked_remarks ?? '-'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="updated_by">
                    <mat-header-cell *matHeaderCellDef> Updated By</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="fs-13">
                        {{element.created_by?.first_name ?? '-'}} {{element.created_by?.last_name ?? '-'}}
                    </mat-cell>
                </ng-container>
                <mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" [class.blur]="update"></mat-row>
            </mat-table>
            <div class="loadingData" [class.d-none]="!update">
                <logzy-gear-loader></logzy-gear-loader>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10" [length]="pageLength"
                           (page)="pageChanged($event)" aria-label="Select page of Charges">
            </mat-paginator>
        </div>
    </ng-container>
</div>


<ng-template #lifecycleItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            <i [class.flaticon-crane]="item?.location_type?.value=='Depot'"></i>
            <i [class.flaticon-anchor]="item?.location_type?.value=='Port'"></i>
            {{item?.name_display}}
        </span>
        <small class="email">
            {{item?.address}}
        </small>
    </div>
</ng-template>

<ng-template #lifecycleSelectedItem let-item>
    {{item?.name_display}}
</ng-template>